import { BUITheme } from "@blofin/blofin-ui";
import useNav from "./useNav";
import { FC, useEffect, useState } from "react";
import { createHeader } from "../Header/entry";
import Header from "../Header";

const NavHeader: FC<{
  apiConfig: { baseUrl: string };
  showTheme: boolean;
  theme?: BUITheme;
  position?: "sticky" | "fixed";
  bgColor?: string;
  switchTheme?: (theme: BUITheme) => void;
  themeLock?: boolean;
  locale: string | undefined;
  hideSignUpAndLogIn?: boolean;
  isDemoTrading?: boolean;
  hideAllMenus?: boolean;
  outerClass?: string;
  wrapperClass?: string;
}> = (props) => {
  const {
    apiConfig,
    showTheme,
    theme,
    position = "sticky",
    bgColor,
    switchTheme,
    themeLock = false,
    locale,
    hideSignUpAndLogIn,
    hideAllMenus,
    outerClass,
    wrapperClass
  } = props;

  const { sdkUrl, initHeader } = useNav();

  const changeTheme = (cb: (theme: BUITheme) => void) => {
    const theme = localStorage.getItem("theme") || "light";
    if (theme === "light") {
      cb("dark");
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      switchTheme && switchTheme("dark");
      localStorage.setItem("theme", "dark");
    } else {
      cb("light");
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      switchTheme && switchTheme("light");
      localStorage.setItem("theme", "light");
    }
  };

  const [updateThemeFun, setUpdateThemeFun] = useState<(theme: BUITheme) => void>();

  const headerConfig = {
    hideSignUpAndLogIn: hideSignUpAndLogIn,
    showTheme: showTheme,
    position: position,
    baseUrl: apiConfig.baseUrl,
    theme: theme,
    themeLock: themeLock,
    changeTheme: changeTheme,
    locale: locale || "en",
    hideAllMenus: hideAllMenus,
    wrapperClass: wrapperClass
  };

  const initHeaderCallback = () => {
    if (window["blockfin-nav-header"]) {
      window["blockfin-nav-header"]
        .createHeader({ ...headerConfig, env: "client" })
        .then((result: any) => {
          if (result && result.updateTheme) {
            console.log("Header initialization exists");
            setUpdateThemeFun(() => result.updateTheme);
          }
        });
    }
  };

  useEffect(() => {
    if (sdkUrl.header) {
      initHeader(initHeaderCallback);
    } else {
      if (process.env.NODE_ENV === "development") {
        createHeader(headerConfig).then((result) => {
          if (result && result.updateTheme) {
            console.log("Header downgrade initialization");
            setUpdateThemeFun(() => result.updateTheme);
          }
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sdkUrl.header]);

  useEffect(() => {
    if (theme && updateThemeFun) {
      updateThemeFun(theme);
    }
  }, [theme, updateThemeFun]);

  return (
    <div
      className={`blockfin-nav-header h-[64px] w-full ${bgColor ? bgColor : ""} ${outerClass}`}
      id="header"
    >
      <Header {...props} hideAcitvityLogo={true} />
    </div>
  );
};

export default NavHeader;
